/**
 * Récupère le projet complet avec ses pages et cellules
 */
export async function fetchProject(projectId = null) {

    const api_url = 'http://localhost:4000'

    // Utiliser l'API
    const id = projectId;
    
    if (!id) {
        const projectData = await fetch('./project.json');
        return projectData.json();
    } else {
        const projectData = await fetch(`${api_url}/projects/${id}/export`);
        return projectData.json();
    }
}
